import {AppAction} from './AppAction';
import { User } from 'salary-shared';

export class ActionUserLogin extends AppAction<User> {
}

export const ActionUser = {
  login: (user: User) => new ActionUserLogin(user)
};